import { Modal } from "react-bootstrap";
import PropTypes from "prop-types";
import "./styles.scss";

const ModalContainer = ({
  modalTitle,
  modalSubtitle,
  isOpen,
  closeModal,
  crossmarkAction,
  cancelButtonTitle,
  cancelButtonType,
  cancelButtonAction,
  submitButtonTitle,
  submitButtonAction,
  submitButtonType,
  modalSize,
  submitButtonDisabled,
  children,
  closeButtonTitle,
  closeButtonAction,
  createButtonAction,
  createButtonTitle
}) => {
  return (
    <Modal
      show={isOpen}
      onHide={closeModal}
      backdrop="static"
      size={modalSize || "sm"}
      className={"alert-shadow scale-content"}
      style={{ zIndex: 9998 }}
    >
      <Modal.Header>
        <Modal.Title>
          {modalTitle}
          {modalSubtitle && <h6>{modalSubtitle}</h6>}
        </Modal.Title>
        {crossmarkAction && (
          <button onClick={crossmarkAction} className="crossmark">
            <div className="line1" />
            <div className="line2" />
          </button>
        )}
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      {cancelButtonAction || submitButtonAction ? (
        <Modal.Footer>
          {cancelButtonAction && (
            <button
              onClick={cancelButtonAction}
              className="app-button btn-second btn-md"
              type={cancelButtonType}
            >
              {cancelButtonTitle}
            </button>
          )}
          <button
            className="app-button btn-prime btn-md"
            onClick={submitButtonAction}
            type={submitButtonType}
            disabled={submitButtonDisabled}
          >
            {submitButtonTitle}
          </button>
        </Modal.Footer>
      ) : closeButtonAction ? (
        <Modal.Footer>  
          <button
            class="app-button btn-prime btn-md"
            onClick={createButtonAction}
            title={createButtonTitle}
          >
            {createButtonTitle}
          </button>
          <button
            onClick={closeButtonAction}
            className="app-button btn-second btn-md"
            type={cancelButtonType}
          >
            {closeButtonTitle}
          </button>
        </Modal.Footer>
      ) : (
        <></>
      )}
      </Modal>
  );
};

export default ModalContainer;

ModalContainer.propTypes = {
  modalTitle: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  crossmarkAction: PropTypes.func,
  cancelButtonTitle: PropTypes.string,
  cancelButtonType: PropTypes.string,
  cancelButtonAction: PropTypes.func,
  submitButtonTitle: PropTypes.string.isRequired,
  submitButtonType: PropTypes.string,
  submitButtonAction: PropTypes.func,
  modalSize: PropTypes.string,
  children: PropTypes.node.isRequired
};
